import React, { useState } from 'react';
import { openWorkshopFlyerTab } from '../../constants/workshopFlyer';
import { WORKSHOP_2026_PATH } from '../../services/workshop2026Service';
import styles from '../../styles/workshop2026Page.module.css';

const WorkshopShareInviteBlock: React.FC = () => {
  const [copied, setCopied] = useState(false);
  const pageUrl =
    typeof window !== 'undefined'
      ? `${window.location.origin}${WORKSHOP_2026_PATH}`
      : `https://recoverycommons.com${WORKSHOP_2026_PATH}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(pageUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* ignore */
    }
  };

  return (
    <div className={styles.shareInviteBlock}>
      <p className={styles.helperText}>
        Share this page, or print a one-page workshop flyer to share at meetings.
      </p>
      <div className={styles.shareInviteActions}>
        <button type="button" className={styles.shareInviteBtn} onClick={handleCopy}>
          {copied ? 'Copied!' : 'Copy link to this page'}
        </button>
        <button type="button" className={styles.shareInviteBtn} onClick={openWorkshopFlyerTab}>
          View / Print flyer
        </button>
      </div>
    </div>
  );
};

export default WorkshopShareInviteBlock;
